import { forwardRef } from "react";
import type { ShowcaseApproach } from "../../types.ts";
import { SlideEyebrow, SlideHeading } from "../common.tsx";
import { IconDatabase, IconPenAI, IconSideBySide, IconPublish, IconStar } from "../icons.tsx";
import type { SVGProps } from "react";

const STEP_ICONS: Array<(p: SVGProps<SVGSVGElement>) => JSX.Element> = [
  IconDatabase,
  IconPenAI,
  IconSideBySide,
  IconPublish,
];

interface Props {
  index: number;
  approach: ShowcaseApproach;
}

export const ApproachSlide = forwardRef<HTMLElement, Props>(function ApproachSlide(
  { index, approach },
  ref
) {
  return (
    <section ref={ref} className="dz-slide">
      <div className="dz-container">
        <SlideEyebrow index={index} label="The Approach" />
        <SlideHeading plain="How it works." />
        <p className="dz-lede">{approach.summary}</p>
        <div className="dz-approach-grid">
          {approach.steps.map((s, i) => {
            const Icon = STEP_ICONS[i] ?? IconStar;
            return (
              <div className="dz-step" key={i}>
                <div className="dz-step__icon">
                  <Icon />
                </div>
                <h4>{s.title}</h4>
                <p>{s.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
});

